import cx from 'classnames';

import styles from './styles.scss';

interface Step {
  id: number;
  isCompleted?: boolean;
  isCurrentStep: boolean;
}

interface StepIndicatorProps {
  steps: Step[];
  onStepClick: (id: number) => void;
}

export const StepIndicator = ({ steps, onStepClick }: StepIndicatorProps) => {
  return (
    <div className={cx(styles.stepIndicator)} aria-label="step-indicator">
      {steps.map((step) => {
        return (
          <div key={step.id} onClick={() => onStepClick(step.id)}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="13"
              height="12"
              viewBox="0 0 13 12"
              fill="none"
            >
              <circle
                cx="6.5"
                cy="6"
                r="5"
                strokeWidth="2"
                className={cx(styles.circleOut, {
                  [styles.currentStep]: step.isCurrentStep,
                  [styles.completed]: step.isCompleted && !step.isCurrentStep,
                })}
              />

              {step.isCurrentStep && (
                <circle
                  cx="6.5"
                  cy="6"
                  r="1"
                  strokeWidth="2"
                  className={cx(styles.currentStep)}
                />
              )}
            </svg>
          </div>
        );
      })}
    </div>
  );
};
